export default "__VITE_ASSET__DJXCudcp__"